import internalApiClient from '../util/api/internalApiClient';
export { createJsonPatchOperation } from '../util/api/internalApiClient';

type AxiosPromise<T extends any = any> = Promise<{
    data: T;
}>;

type MutationResult<TRequest extends any, TResponse extends any> = (data: TRequest) => AxiosPromise<TResponse>;

export default function useMutation<TRequest extends any, TResponse extends any = any>(
    url: string,
    method: 'POST' | 'PUT' | 'PATCH' | 'DELETE' = 'POST'
): MutationResult<TRequest, TResponse> {
    return (data?: TRequest) => internalApiClient[method.toLowerCase()](url, data);
}
